export default __webpack_public_path__ + "static/media/ri_lock-password-line.06ebe1f3.svg";